<template>
	<!-- <v-container > -->
	<div v-resize="resize" ref="moncard" style="width: 100%">
		<div>
			<v-data-table
				style="background-color: transparent"
				:height="tableHeight"
				:headers="headers"
				:items="decodedTableData"
				:loading="tableLoading"
				:page.sync="page"
				:footer-props="footerProps"
				:items-per-page="15"
				:item-class="isComercialCobOrRec ? '' : itemRowBackground"
				:server-items-length="totalEntries"
				:options.sync="options"
				class="px-2"
				ripple
				hide-default-footer
			>
				<template v-slot:footer="{ props }">
					<v-row style="position: absolute; width: 120px">
						<v-col class="mt-3">
							<Dial />
						</v-col>
						<v-col style="margin-top: 16px">
							<v-row :class="!$vuetify.breakpoint.xsOnly ? 'mx-n7' : 'pr-12 ml-n12'">
								<v-col cols="4" class="d-flex justify-start">
									<v-tooltip top>
										<template
											v-slot:activator="{ on, attrs }"
										>
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												:value="
													timeLeft ? timeLeft + 15 : 0
												"
												color="green"
												width="5"
											>
												<v-icon class="ma-1" size="22">
													mdi-clock
												</v-icon>
											</v-progress-circular>
										</template>
										<div class="d-flex flex-column">
											<span>Tiempo Restante</span>
											<span>Antes de Buscar</span>
										</div>
									</v-tooltip>
								</v-col>
								<v-col
									cols="4"
									class="mt-1 d-flex justify-start"
								>
									<transition name="fade">
										<v-badge
											color="orange"
											offset-y="10"
											offset-x="7"
											:value="n_filters"
											:content="n_filters"
											v-if="n_filters"
											bordered
											hover
										>
											<v-tooltip top>
												<template
													v-slot:activator="{
														on,
														attrs,
													}"
												>
													<v-icon
														class="ml-2"
														v-bind="attrs"
														v-on="on"
													>
														mdi-magnify
													</v-icon>
												</template>
												<div class="d-flex flex-column">
													<span>Nº de</span>
													<span>Filtros</span>
												</div>
											</v-tooltip>
										</v-badge>
									</transition>
								</v-col>
								<v-col cols="4" class="d-flex justify-start">
									<v-tooltip v-if="n_filters" top>
										<template
											v-slot:activator="{ on, attrs }"
										>
											<transition name="fade">
												<v-icon
													class="ml-4"
													@click="deleteFilters"
													v-bind="attrs"
													v-on="on"
													>mdi-close
												</v-icon>
											</transition>
										</template>
										<div class="d-flex flex-column">
											<span>Borrar</span>
											<span>Filtros</span>
										</div>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
					<!-- <v-spacer></v-spacer> -->
					<v-data-footer
						style="height: 60px; justify-content: flex-end"
						:items-per-page-options="props.itemsPerPageOptions"
						:options.sync="options"
						:pagination.sync="props.pagination"
						show-first-last-page
					>
						<template
							v-slot:prepend=""
							v-if="!$vuetify.breakpoint.xsOnly"
						>
							<div class="mb-n3" style="width: 205px !important">
								<v-autocomplete
									dense
									v-model="page"
									prepend-icon="mdi-book-open-page-variant"
									:items="pagesOptions"
									:loading="tableLoading"
									:disabled="tableLoading"
									type="number"
								>
									<template v-slot:selection="item">
										<small class="font-weight-light">
											Página - {{ item.item }}</small
										>
									</template>

									<template v-slot:item="item">
										<small
											class="font-weight-light text-center"
											>{{ item.item }}</small
										>
									</template>
								</v-autocomplete>
							</div>
						</template>
					</v-data-footer>
				</template>
				<template v-slot:item.comercial="{ item }">
					{{ getCommercialName(item.lastComercial) }}
				</template>
				<template v-slot:item.telefonosContacto="{ item }">
					{{
						item.telefonosContacto && item.telefonosContacto[0]
							? item.telefonosContacto[0]
							: ''
					}}
				</template>
				<template v-slot:item.fechaContacto="{ item }">
					{{ formatDate(item.lastAtencionContactoDate) }}
				</template>
				<template v-slot:item.lastGestion="{ item }">
					<v-tooltip v-if="item.lastGestion" max-width="470px" top>
						<template v-slot:activator="{ on, attrs }">
							<div
								class="d-flex justify-space-between"
								v-bind="attrs"
								v-on="on"
							>
								<div>
									{{ item.lastGestion.substr(0, 21) }}
									...
								</div>
								<v-icon>mdi-message-reply-text-outline</v-icon>
							</div>
						</template>
						<span class="pa-2 text-justify">{{
							item.lastGestion
						}}</span>
					</v-tooltip>
				</template>
				<!-- <template v-slot:item.updatedOn="{ item }">
                    {{
                        item.lastAtencion && item.lastAtencion[0]
                            ? formatDate(item.lastAtencion[0].updatedOn)
                            : ''
                    }}
                </template> -->
				<!-- <template v-slot:item.fechaAgendado="{ item }">
                    {{ item.lastAtencion[0] ? formatDate(item.lastAtencion[0].oferta.fechaAgendado) : '' }}
                </template> -->
				<template v-slot:item.actions="{ item }">
					<v-row
						v-if="hasSuperAdminPermission"
						:class="$vuetify.breakpoint.mdOnly ? 'py-4' : ''"
					>
						<v-col>
							<v-icon
								:class="$vuetify.breakpoint.mdOnly ? 'mb-0' : 4"
								v-on:click.stop
								@click="viewItem(item)"
							>
								mdi-clipboard-account-outline
							</v-icon>
						</v-col>
						<v-col>
							<v-icon v-on:click.stop @click="editItem(item)">
								mdi-pen
							</v-icon>
						</v-col>
						<v-col>
							<v-icon v-on:click.stop="openDeleteDialog(item)">
								mdi-delete
							</v-icon>
						</v-col>
						<!-- <v-col v-if="ckeckGroupPermission([GROUPS.MASMOVIL])">
							<v-icon
								v-on:click.stop
								@click="detailItem(item)"
								:disabled="
									!item.documento ||
									['LlamaYa', 'Grupo MM'].includes(
										item.ispActual
									) || checkTimeInIntervalDetailedView
								"
							>
								align mdi-page-next-outline
							</v-icon>
						</v-col> -->
					</v-row>
					<v-row
						v-else
						:class="$vuetify.breakpoint.mdOnly ? 'py-2' : ''"
					>
						<v-col :cols="$vuetify.breakpoint.mdOnly ? 12 : 4">
							<v-icon
								:class="$vuetify.breakpoint.mdOnly ? 'mb-0' : 4"
								v-on:click.stop
								@click="viewItem(item)"
							>
								mdi-clipboard-account-outline
							</v-icon>
						</v-col>
						<v-col :cols="$vuetify.breakpoint.mdOnly ? 12 : 4">
							<v-icon v-on:click.stop @click="editItem(item)">
								mdi-pen
							</v-icon>
						</v-col>
						<!-- <v-col :cols="$vuetify.breakpoint.mdOnly ? 12 : 4">
							<v-icon
								v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
								v-on:click.stop
								@click="detailItem(item)"
								:disabled="
									!item.documento ||
									['LlamaYa', 'Grupo MM'].includes(
										item.ispActual
									) || checkTimeInIntervalDetailedView"
							>
								mdi-page-next-outline
							</v-icon>
						</v-col> -->
					</v-row>
				</template>
			</v-data-table>
		</div>
		<v-dialog
			v-model="deleteDialog"
			v-if="hasSuperAdminPermission"
			width="unset"
		>
			<v-card width="700" class="pa-2">
				<div class="d-flex justify-space-between px-4">
					<h1 class="px-3 font-weight-light text-center">
						¿Está seguro de que quiere borrar a {{ userToDelete }} ?
					</h1>
					<v-icon size="90" color="orange"> mdi-alert </v-icon>
				</div>
				<div class="pt-4">
					<p class="px-6 font-weight-light text-center">
						<v-icon color="red">mdi-delete</v-icon>
						Recuerde proceder con cautela, este cambio podría ser
						irreversible y afectar a la consistencia en los datos ya
						existentes en la base de datos. Consulte con los
						administradores si no está seguro de lo que está
						haciendo.
					</p>
				</div>
				<v-card-actions>
					<v-spacer />
					<v-btn color="red" text @click="closeDeleteDialog()">
						Cerrar
					</v-btn>
					<v-btn color="error" @click="deleteItem(currentItem)">
						Borrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div id="control-height"></div>
		<DownloadTemplateAndUpload
			v-if="ckeckGroupPermission([GROUPS.AVATEL])"
			message="Subir plantilla con direcciones"
			:multiple="false"
			title="Comprobación de cobertura"
			templateMutationPath="gerencia/download_template_from_json"
			templatePath="coverageTemplate.json"
			submitMutationPath="gerencia/importFiles"
			submitPath="process_avatel_coverage"
			@submitted="submittedXLSX($event)"
		/>
	</div>
</template>

<script>
//  import {decodeForm} from '@/util/libForm.js'
import Dial from './Dial.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { formatDate, checkTimeInInterval } from '@/util/libUtil.js';
import DownloadTemplateAndUpload from '@/components/DownloadTemplateAndUpload/DownloadTemplateAndUpload.vue';

export default {
	name: 'DataBaseView',
	components: {
		Dial,
		DownloadTemplateAndUpload,
	},
	data: () => ({
		timeLeft: 0,
		lastTypeTime: null,
		decodedTableData: [],
		headers: [
			{
				text: 'Nombre',
				align: 'start',
				filterable: true,
				value: 'nombre',
			},
			{
				text: 'Identificación',
				value: 'documento',
			},
			{
				text: 'Telf',
				value: 'telefonosContacto',
			},
			{
				text: 'Fecha contacto',
				value: 'fechaContacto',
			},
			// {
			//     text: 'Actualizado',
			//     value: 'updatedOn',
			// },
			// {
			//     text: 'Fecha agendado',
			//     value: 'fechaAgendado'
			// },
			{
				text: 'Comercial',
				value: 'comercial',
				// sortable: false
			},
			{
				text: 'Última gestión',
				value: 'lastGestion',
				width: '250',
				align: 'center',
				sortable: false,
			},
			{
				text: 'Estado',
				value: 'estado',
			},
			{
				text: 'Operador',
				value: 'ispActual',
			},
			{
				text: 'Segmento',
				value: 'segmento',
			},
			{
				text: '',
				value: 'actions',
				sortable: false,
			},
		],
		tableHeight: 300,
		footerProps: {
			disableItemsPerPage: true,
			itemsPerPageOptions: [0],
		},
		previous: '',
		options: {},
		componentKey: 0,
		firstloaded: true,
		userToDelete: null,
		deleteDialog: false,
		currentItem: null,
	}),
	methods: {
		formatDate,
		checkTimeInInterval,
		submittedXLSX(data) {
			console.log('submittedXLSX', data);
		},
		itemRowBackground: function (item) {
			const findComercial = this.comerciales.find(
				(comercial) => comercial.id === item.lastComercial
			);

			if (
				findComercial &&
				findComercial.tipoComercial == 'RECOMENDADOR' &&
				(this.cuenta.tipoComercial == 'TIENDA' ||
					this.hasAdminPermission)
			) {
				return 'azul';
			}
		},
		getCommercialName(id) {
			return this.comerciales.find((comercial) => comercial.id == id)
				?.nombreCompleto;
		},
		deleteFilters() {
			this.$root.$emit('deleteTableFilters');
			this.$store.commit('util/navBarSearchField', '');
		},
		getComercialNombreFromId(id) {
			let comercial = this.$store.state.teletrabajo.Comerciales.find(
				(comercial) => comercial.id == id
			);
			return comercial ? comercial.nombre : '';
		},
		decodeData: function (data) {
			return data;
		},
		resize() {
			this.tableHeight =
				document.getElementById('control-height').clientHeight -
				37 -
				32 -
				8 -
				16 -
				15;
		},
		viewItem(item) {
			this.$store.dispatch('teletrabajo/viewTtForm', item);
		},
		detailItem(item) {
			this.$store.dispatch('teletrabajo/detailedView', item.documento);
		},
		openDeleteDialog(item) {
			this.deleteDialog = true;
			this.userToDelete = item.nombre;
			this.currentItem = item;
		},
		closeDeleteDialog() {
			this.deleteDialog = false;
		},
		deleteItem(item) {
			this.$store.dispatch('teletrabajo/deleteTtForm', item);
			this.closeDeleteDialog();
		},
		checkTimeout(val) {
			let difference = new Date().getTime() - this.lastTypeTime;
			// Si no escribimos en un segundo se hará una petición para buscar el elemento en BD
			setTimeout(() => {
				// Esta vaina es para que se vea cuanto tiempo queda hasta que se busque en el circular progress
				// despues de escribir.
				let calc =
					((1000 - (new Date().getTime() - this.lastTypeTime)) /
						1000) *
					100;
				if (Math.abs(calc - this.timeLeft) > 5) this.timeLeft = calc;

				if (difference > 500) {
					if (!val || val.length == this.search.length) {
						this.timeLeft = 0;
						this.page = 1;
						this.options.page = 1;
						this.$store.dispatch('teletrabajo/updateQueryParams', {
							search: this.search,
							...this.options,
						});
						this.$store.dispatch('teletrabajo/getTableData');
					}
				} else this.checkTimeout(val);
			}, 500);
		},
		...mapActions('teletrabajo', {
			editItem: 'editTtForm',
		}),
	},
	mounted() {},
	watch: {
		options: {
			immediate: false,
			handler() {
				let page = this.options.page;
				setTimeout(() => {
					if (
						this.options.page == page &&
						!this.tableLoading &&
						!this.firstloaded
					) {
						this.$store.dispatch(
							'teletrabajo/updateQueryParams',
							this.options
						);
						this.$store.dispatch('teletrabajo/getTableData');
					}
				}, 200);
			},
			// Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
			deep: true,
		},
		search: {
			immediate: true,
			handler(val) {
				this.timeLeft =
					((1000 - (new Date().getTime() - this.lastTypeTime)) /
						1000) *
					110;
				this.lastTypeTime = new Date().getTime();
				this.checkTimeout(val);
			},
			deep: true,
		},
		TableData() {
			this.decodedTableData = this.decodeData(
				JSON.parse(JSON.stringify(this.TableData))
			);
		},
		tableHeight() {
			this.footerProps.itemsPerPageOptions[0] = Math.floor(
				this.tableHeight / 48 - 1
			);
			this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
			this.firstloaded = false;
		},
		totalEntries() {
			if (this.totalEntries <= this.footerProps.itemsPerPageOptions[0]) {
				//  this.options.page = 1
			}
		},
	},
	computed: {
		checkTimeInIntervalDetailedView() {
			let intervalStart = new Date();
			intervalStart.setUTCHours(7, 0);
			let intervalEnd = new Date();
			intervalEnd.setUTCHours(22, 0);

			return !checkTimeInInterval(intervalStart, intervalEnd);
		},
		pagesOptions() {
			let optsLen = this.totalEntries / this.decodedTableData.length;

			if (!Number.isNaN(optsLen) && optsLen != Number.POSITIVE_INFINITY) {
				return Array.from(
					{ length: Math.ceil(optsLen) },
					(v, k) => k + 1
				);
			}
			return [1];
		},
		cuenta() {
			return JSON.parse(localStorage.getItem('cuenta'));
		},
		communicates() {
			return JSON.parse(localStorage.getItem('communicates'));
		},
		page: {
			get() {
				return this.$store.state.teletrabajo.TablePage;
			},
			set(val) {
				this.$store.commit('teletrabajo/TablePage', Number(val));
			},
		},
		...mapState('login', {
			groups: (state) => state.groups,
		}),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			ckeckGroupPermission: 'ckeckGroupPermission',
			hasSuperAdminPermission: 'hasSuperAdminPermission',
			hasAdminPermission: 'hasAdminPermission',
			hasManagerPermission: 'hasManagerPermission',
			isComercialCobOrRec: 'isComercialCobOrRec',
		}),
		...mapState({
			comerciales: (state) => state.teletrabajo.Comerciales,
			n_filters: (state) => state.teletrabajo.N_Filters,
			TableData: (state) => state.teletrabajo.TableData,
			totalEntries: (state) => state.teletrabajo.TotalTTEntries,
			tableLoading: (state) => state.teletrabajo.IsTableLoading,
			search: (state) => state.util.navBarSearchField,
		}),
	},
};
</script>

<style>
#control-height {
	height: 100vh;
	width: 0;
	position: absolute;
}
#center {
	height: 100%;
	width: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}

.fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.azul {
	background-color: #baccff;
}
</style>